module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_null_null.69a91f9d.png";